import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { debounce } from 'lodash';
import { toast } from 'react-toastify';

import { getCurrentUserTokens, refreshUserTokens } from '../utils/aws';
import { logout } from '../App/Login/loginActions';
import { REFRESH_TOKEN } from '../App/Refresh/refreshActions';

//ID & Access Token expire after 1 hour
//Refresh token expires after 30 days
//We want to logout users after 15 minutes into the hour

const secondsRemainingThreshold = 45 * 60; //seconds in 45 minutes
const timeoutPeriod = 15 * 60 * 1000; //milliseconds in 15 minutes
const debouncedLogout = debounce((dispatch) => dispatch(logout()), timeoutPeriod);
const debouncedRefreshTokens = debounce(refreshUserTokens, 1000, { maxWait: 10000 });

const tokenMiddleware = ({ dispatch }) => (next) => (action) => {
    if (!action.forceSkipTokenMiddleware && (action.successActionTypeOrCreator || action.type === REFRESH_TOKEN)) {
        getCurrentUserTokens().then((userTokens) => {
            const decodedToken = jwtDecode(userTokens.accessToken);
            const currentEpochTime = moment().unix();

            const secondsBeforeTokenExpires = decodedToken.exp - currentEpochTime;

            if (secondsBeforeTokenExpires <= secondsRemainingThreshold) {
                dispatch(logout());
            } else {
                debouncedRefreshTokens(userTokens.refreshToken, dispatch);
            }

            debouncedLogout(dispatch);

            next(action);
        }).catch((error) => {
            toast(error, { type: 'error' });
            dispatch(logout());
        });
    } else {
        next(action);
    }
};

export default tokenMiddleware;
